import { Hole, Item, SceneObjects } from '@types'

export function isHoleOrItem(holeOrItem?: SceneObjects): holeOrItem is Hole | Item {
  return !!holeOrItem && (holeOrItem?.type === 'holes' || holeOrItem.type === 'items')
}
